<span #fakeOrigin cdkOverlayOrigin style="display: none"></span>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOpen]="true"
  [cdkConnectedOverlayOrigin]="fakeOrigin"
  [cdkConnectedOverlayDisableClose]="true"
>
  <div class="expanded-panel-wrapper" [class.expanded-panel-wrapper--collapsed]="!expanded">
    <div
      class="expanded-panel-container"
      [@slideInOut]="expanded ? 'open' : 'closed'"
      (@slideInOut.done)="onAnimDone($event)"
    >
      <div class="expanded-panel-header">
        <ng-content select="[expanded-panel-header-content]"></ng-content>
        <div class="expanded-panel-controls-section">
          <mat-icon
            svgIcon="close"
            class="expanded-panel-close-button"
            (click)="onButtonClicked('close')"
          ></mat-icon>
          <ng-content select="[expanded-panel-chips]"></ng-content>
        </div>
      </div>
      <div class="expanded-panel-body">
        <ng-content select="[expanded-panel-body]"></ng-content>
      </div>
      <div class="expanded-panel-footer" (click)="onButtonClicked('collapse')">
        <mat-icon svgIcon="collapse" class="expanded-panel-collapse-button"></mat-icon>
        Collapse
      </div>
    </div>
  </div>
</ng-template>
